// libraries.
import { useState, useEffect } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import { useSelector, useDispatch } from 'react-redux';

// slices.
import {
  getIsModalOpen,
  closeModal,
  setComment,
  setPropertyType,
  getPolygons,
} from '@domains/polygon-tool/store/slices/polygon-slice';
import { getCountry } from '@domains/user/store/slices/user-slice/user-slice';

// components.
import { PropertyTypeCheckbox } from './PropertyTypeCheckbox';

// styles.
import { WrapperModal } from './styles';

export const PolygonCommentModal = () => {
  const dispatch = useDispatch();
  const showModal = useSelector(getIsModalOpen);
  const polygons = useSelector(getPolygons);
  const country = useSelector(getCountry);

  const [isDuplexChecked, setIsDuplexChecked] = useState(false);

  const lastPolygonIndex = polygons.length - 1;
  const isMexico = country === 'MX';

  useEffect(() => {
    if (!showModal) {
      setIsDuplexChecked(false);
    }
  }, [showModal]);

  const handleClose = () => {
    dispatch(closeModal());
  };

  const handleSave = () => {
    handleClose();
  };

  const handleComment = (newComment: string) => {
    dispatch(setComment({ index: lastPolygonIndex, comment: newComment }));
  };

  const handlePropertyType = (propertyTypeId: string) => {
    setIsDuplexChecked(propertyTypeId !== '');

    dispatch(
      setPropertyType({
        index: lastPolygonIndex,
        property_type_id: propertyTypeId,
        property_type: propertyTypeId === '5' ? 'Dúplex' : '',
      })
    );
  };

  return (
    <Modal show={showModal} onHide={handleClose} centered>
      <WrapperModal>
        <Modal.Header className="d-flex justify-content-center p-0 py-2 border-bottom-0">
          <Modal.Title>Información del polígono</Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-0 pb-3">
          <Form>
            {isMexico && (
              <PropertyTypeCheckbox
                isChecked={isDuplexChecked}
                onChange={handlePropertyType}
              />
            )}
            <Form.Group
              className="d-flex flex-column"
              controlId="commentTextarea"
            >
              <Form.Label className="text-start">
                Deja un comentario del polígono que acabas de crear (opcional)
              </Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                onChange={e => handleComment(e.target.value)}
                placeholder="Escribir..."
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer className="flex-nowrap p-0 pb-1 border-top-0">
          <Button className="btn-habi-white w-100" onClick={handleClose}>
            Omitir
          </Button>
          <Button className="btn-habi w-100" onClick={handleSave}>
            Guardar
          </Button>
        </Modal.Footer>
      </WrapperModal>
    </Modal>
  );
};
